import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './infos-product.component'

let module = angular.module('infosProduct', [
  uiRouter
])

.component('infosProduct', component)
.factory('PurchaseInfos', function () {
  return {
    loadingB2BPrice: false
  }
})

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/manage-purchase/my-purchase/infos-product/index.js